export const headPrimaryColor = "";
export const headSecondColor = "";
export const mainHeaderbg = "#fff";
export const headColor = "#EC1B30";
